import * as React from "react";
import { cn } from "../../lib/utils";

export function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-md bg-[hsl(var(--bg-elev-2))] relative overflow-hidden",
        "after:absolute after:inset-0 after:-translate-x-full after:animate-shimmer",
        "after:bg-[linear-gradient(90deg,transparent,hsl(var(--border)/0.4),transparent)]",
        className
      )}
      {...props}
    />
  );
}
